export default {
  descricao: {
    value: null,
    maxlength: 200,
    required: true,
    state: null
  },
  cliente: {
    value: null,
    maxlength: 50,
    required: true,
    state: null
  },
  regiao: {
    value: null,
    maxlength: 50,
    required: true,
    state: null
  },
  revisao: {
    value: 1,
    required: true,
    state: null
  },
  observacao: {
    value: null,
    required: false,
    state: null
  },
  itens: {
    value: [],
    required: false,
    state: null
  },
  colunas: {
    value: [],
    required: false,
    state: null
  }
}



// WEBPACK FOOTER //
// ./src/views/private/operational/pci/lpu/lpu-form.js